import React, { useState }  from 'react';
import styled from 'styled-components';
import { ButtonBack, ButtonNext, CarouselProvider, Dot, Slide, Slider } from "pure-react-carousel";
import 'pure-react-carousel/dist/react-carousel.es.css';
import { IconChevron } from '../../Assets/IconChevron';
import { Link } from 'react-router-dom';
const Styles = styled.div`
  position: relative;
  margin: 0 0 1rem;
  &.rtl {
    direction: ltr;
  }

  * {
    overflow: visible;
  }
  .slideHorizontal___1NzNV,
  .horizontalSlider___281Ls {
    transform: scale(1) !important;
  }
  .carousel {
    * {
        overflow: visible;
    }
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    background-color: var(--body-1);
    display: flex;
    flex-direction: column;
    position: relative;
    .main-slide{
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      transition: all 0.3s ease-in-out;
      img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          overflow: hidden;
      }
      video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          overflow: hidden;
      }
    }
    .slider-good-visible {
      .slidetype-1 {
        --anim-time-1: 2s;
        --anim-delay-1: 0.2s;
        .text-img {
          inset: 0;
          opacity: 1;
        }
      }
    }
  }
  .arrow {
    position: absolute;
    top: calc(calc(100% - 46px) / 2);
    padding: 1rem 0.5rem;
    background: #FFFFFFea;
    border-radius: 100px;
    border: none;
    cursor: pointer;
    &::before {
        content: "";
        z-index: -1;
        position: absolute;
        inset: -1px;
        background: linear-gradient(180deg, #E5E5E5 0%, #7F7F7F00 100%);
        border-radius: 100px;
    }
    svg {
        display: block;
    }
    &.left {
        left: calc(var(--universal-pad) / 2);
    }
    &.right {
        right: calc(var(--universal-pad) / 2);
    }
    /* .icon {
        font-size: 2.3rem;
    } */
  }   
  .dots {
    position: absolute;
    bottom: 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 4px;
    .dot {
        border: none;
        outline: none;
        width: 8px;
        height: 8px;
        border-radius: 100px;
        background-color: var(--n-grey-1);
        padding: 0;
        transition: all 0.2s ease-in-out;
        &:disabled {
            background-color: var(--prime-1);
            width: 16px;
        }
    }
  }
  @media screen and (max-width:850px) {
    .arrow {
      display: none;
    }
  }
`
export default function SliderNormal1 (props){
  const {data: dataRaw, lan} = props;
  const [hover, setHover] = useState(false);
  const data = JSON.parse(dataRaw);
  
  const slides = (src, link) => {
    let type = src.split(".");
    type = type[type.length - 1];
    let newimage = src;
    if(type !== "mp4"){
        // newimage = src.replace(process.env.REACT_APP_API+"/images", process.env.REACT_APP_CACHE);
    }
    let size = "?size=2000"
    if(window.innerWidth < 850){
        size = "?size=750"
    }
    return(
      <Link to={"/" + lan.filename + link} className="main-slide slidetype-1">
          {
              (type === "mp4" || type === "webm") ? (
                  <video autoPlay loop muted playsInline>
                      <source src={newimage} type={"video/" + type} />
                  </video>
              ) : (
                  <img src={newimage+size} alt={"/" + lan.filename + link}/>
              )
          }
      </Link>
    );
  }
  let height = 28.00;
  if(window.innerWidth < 850){
      height = 89.44;
  }
  let rtl = false;
  if(lan.dir === "rtl"){
    rtl = true;
  }
  let slidesImage = data.Images.map((v, i) => {
    let src=  v.ImageDesktop
    let link = v.link;
    if(window.innerWidth < 850){
        src=  v.ImageMobile
    }
    return (
        <Slide 
            key={i} 
            index={data.Images.length - (i+1)} 
            classNameVisible="slider-good-visible"
            onPointerEnter={() => {
                setHover(true)
            }}
            onPointerMove={() => {
                setHover(true)
            }}
            onPointerLeave={() => {
                setHover(false)
            }}
        >
            {slides(src, link)}
        </Slide>
    )
  })
  let dots = data.Images.map((v, i) => {
    return (
        <Dot
            className="dot"
            key={i}
            slide={rtl ? data.Images.length - (i+1) : i}
        >
    
        </Dot>
    )
  })
  return (
    <Styles className={' ' + lan.dir}>
      <CarouselProvider
          naturalSlideWidth={100}
          naturalSlideHeight={height}
          totalSlides={data.Images.length}
          playDirection={rtl ? "backward" :"forward" }
          currentSlide={rtl ? data.Images.length - 1 :  0}
          visibleSlides={1}
          isPlaying={(window.innerWidth < 850) ? true : !hover}
          interval={6000}
      >
          <Slider>
              {
                  (rtl) ? slidesImage.reverse() : slidesImage
              }
          </Slider>
          {
            (slidesImage.length === 1) ? "" : (
              <>
                <ButtonNext className="arrow right"><IconChevron className="icon"/></ButtonNext>
                <ButtonBack className="arrow left"><IconChevron className="icon"  style={{rotate: "180deg"}}/></ButtonBack>
                <div className="dots">
                    {
                        (rtl) ? dots.reverse() : dots
                    }
                </div>
              </>
            )
          }
      </CarouselProvider>
    </Styles>
  )
}

